import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useStudyContext } from '../../../../../common/context/study/useStudyContext';
import { SiteDetailsUrlParams } from '../../../model/SiteDetailsUrlParams';
import { SiteDetailsContextState } from '../model/SiteDetailsContextState';

export const useSiteDetailsContextProvider = (): SiteDetailsContextState => {
  const { siteId } = useParams<SiteDetailsUrlParams>();
  const { study } = useStudyContext();

  // We need to listen for updates on study.sites because updateSitesReducer will modify that and changes won't be picked up otherwise
  const site = useMemo(() => study.sites.find(({ orgId }) => orgId === siteId), [siteId, study.sites]);

  return {
    site,
  };
};
